import React, { Fragment } from 'react';
import { Tab } from '@headlessui/react';
import { TabListItem } from './Tab';
import { IColor, ILabel } from '../../../../utils/types/contentful';
import { Body, IBodyProps } from '../../Elements/Body/body';

export interface ITab {
  label?: ILabel;
  children: React.ReactElement;
  color: IColor;
  body: IBodyProps;
  selected: boolean;
}

export interface ITabs {
  items: ITab[];
}

export const TabList: React.FC<ITabs> = ({ items }) => (
  <nav
    className='-mb-px flex space-x-8 border-b'
    aria-label='Tabs'>
    {items &&
      items.map((tabListItem) => (
        <Tab as={Fragment}>
          {({ selected }) => (
            <div className={`h-10 opacity-${!selected && '50'}`}>
              <TabListItem
                {...tabListItem}
                selected={selected}
              />
            </div>
          )}
        </Tab>
      ))}
  </nav>
);
